import { useState } from "react";
import { HeartPulse, OctagonX, Sprout, Timer } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";
import { useI18n } from "../../i18n";

export const StopButton = ({ onConfirm }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button data-testid="stop-session-button" onClick={() => setOpen(true)}
        className="flex h-14 items-center gap-2 rounded-full bg-red-600 px-5 text-sm font-extrabold tracking-wide text-white shadow-lg shadow-red-900/20 transition-transform active:scale-95">
        <OctagonX className="h-5 w-5" /> {t("stop")}
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="max-w-sm rounded-3xl border-0 bg-white text-[#0A2540] opacity-100 shadow-2xl">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-2xl">{t("stopSession")} ?</AlertDialogTitle>
            <AlertDialogDescription className="text-base">Vos progrès déjà réalisés sont enregistrés. Vous pouvez arrêter à tout moment.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="gap-2">
            <AlertDialogCancel data-testid="stop-cancel-button" className="h-14 rounded-full text-base">Continuer</AlertDialogCancel>
            <AlertDialogAction data-testid="stop-confirm-button" onClick={onConfirm} className="h-14 rounded-full bg-red-600 text-base hover:bg-red-700">Arrêter la séance</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export const HudChip = ({ icon: Icon, children, testId, onClick }) => (
  <button data-testid={testId} onClick={onClick} disabled={!onClick}
    className="flex h-14 min-w-14 items-center justify-center gap-1.5 rounded-full bg-white/85 px-3 text-base font-bold text-[#0A2540] shadow-md backdrop-blur-md disabled:cursor-default">
    <Icon className="h-5 w-5 text-[#17A2A2]" />{children}
  </button>
);

export const GameHud = ({ onStop, seeds, onPain, remaining }) => {
  const { t } = useI18n();
  const mm = Math.max(0, Math.floor(remaining / 60)), ss = String(Math.max(0, remaining % 60)).padStart(2, "0");
  return (
    <div className="safe-top absolute inset-x-0 top-0 z-30 px-3 pb-3 no-print">
      <div className="flex items-center justify-between gap-2">
        <StopButton onConfirm={onStop} />
        <div className="flex gap-2">
          {remaining !== undefined && <HudChip icon={Timer} testId="hud-timer">{mm}:{ss}</HudChip>}
          <HudChip icon={Sprout} testId="hud-seeds">{seeds}</HudChip>
          {onPain && <HudChip icon={HeartPulse} testId="hud-pain-button" onClick={onPain} />}
        </div>
      </div>
      <div className="mt-2 inline-block rounded-full bg-[#0A2540]/75 px-3 py-1 text-[10px] font-bold tracking-widest text-white" data-testid="simulated-data-label">
        {t("simulated")}
      </div>
    </div>
  );
};
